import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useMultiParentlessResourceAdapterActions } from '../../../resource-base/adapters/useMultiParentlessResourceAdapterActions';
import {
    defaultNamedPersistableResource,
    NamedPersistableResourceSchema,
} from '../../../resource-base/persistableResourceTypes';

export enum SystemUserRolePropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    IS_ADMIN = 'IS_ADMIN',
    IS_SERVER_ADMIN = 'IS_SERVER_ADMIN',
    IS_READER_OF_ALL_PROJECTS = 'IS_READER_OF_ALL_PROJECTS',
    IS_PROCESS_ADMIN_OF_ALL_PROJECTS = 'IS_PROCESS_ADMIN_OF_ALL_PROJECTS',
    IS_MANAGER_OF_ALL_PROJECTS = 'IS_MANAGER_OF_ALL_PROJECTS',
}

export const SystemUserRoleResourceSchema = NamedPersistableResourceSchema.extend({
    description: z.string(),
    isManagerOfAllProjects: z.boolean(),
    isProcessAdminOfAllProjects: z.boolean(),
    isReaderOfAllProjects: z.boolean(),
    isAdmin: z.boolean(),
    isServerAdmin: z.boolean(),
    resourceType: z.literal(ResourceType.SYSTEM_USER_ROLE).default(ResourceType.SYSTEM_USER_ROLE),
});

export const SystemUserRoleMutationResourceSchema = getMutationSchema(SystemUserRoleResourceSchema);

export type SystemUserRoleResource = z.infer<typeof SystemUserRoleResourceSchema>;

export const defaultSystemUserRoleResource: SystemUserRoleResource = {
    ...defaultNamedPersistableResource,
    resourceType: ResourceType.SYSTEM_USER_ROLE,
    description: '',
    isManagerOfAllProjects: false,
    isProcessAdminOfAllProjects: false,
    isReaderOfAllProjects: false,
    isAdmin: false,
    isServerAdmin: false,
};

export function useSystemUserRoleActions() {
    return useMultiParentlessResourceAdapterActions(
        'system-user-role',
        ResourceType.SYSTEM_USER_ROLE,
        SystemUserRoleResourceSchema
    );
}
